import { render, staticRenderFns } from "./MasterplanStreetsWidget.vue?vue&type=template&id=128a72a2&scoped=true&"
import script from "./MasterplanStreetsWidget.vue?vue&type=script&lang=js&"
export * from "./MasterplanStreetsWidget.vue?vue&type=script&lang=js&"
import style0 from "./MasterplanStreetsWidget.vue?vue&type=style&index=0&id=128a72a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a72a2",
  null
  
)

export default component.exports